import {EventProfileInterface} from './Events/EventProfileInterface';
import {RenderProfileInterface} from './Renders/RenderProfileInterface';
/*
 * Профиль пользователя
 */
export class Profile {

    private profileElements: HTMLCollectionOf<HTMLElement>;

    constructor(profileElements:any) {
        this.profileElements = profileElements;
    }

    addEvent(eventProfile: EventProfileInterface) {
        eventProfile.watch(this.profileElements);
    }

    render(eventProfile: RenderProfileInterface) {
        eventProfile.render(this.profileElements);
    }

}
